import React from 'react';
import { render } from 'react-dom';

import Carousel from '../react/Carousel';

export default class CarouselRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { model } = this.context.dataset;
    if (!model) throw Error('Missing a required dataset');
    const jsonModel = JSON.parse(model);

    render(<Carousel items={jsonModel} sideButtons />, this.context);
  }
}
